module.exports = __webpack_public_path__ + "img/right-logo.711f5b61.png";